import { RequestParamInterface, hasParam } from './requestParamsEncoder';

export default function encodeFilter(params: RequestParamInterface) {
    if (!hasParam('filter', params) || (params.filter as string).length) {
        return;
    }
    // We don't transmit the filter parameter if it is an empty string
    delete params.filter;
}
